import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import routes from "../routes";
import "../index.css";
import Sidebar from "../components/Sidebar";
import Dashboard from '../pages/Dashboard.js';
import News from '../pages/News';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Celebrities from '../pages/Celebrities.js';
import Idea from '../pages/Idea.js';
import OldProducts from '../pages/OldProducts.js';
import InternalNews from "../pages/internalPages/InternalNews";
import InternalCelebrities from "../pages/internalPages/InternalCelebrities";
import InternalPlaces from "../pages/internalPages/InternalPlaces";
import Amlak from "../pages/Amlak";
import Profile from "../pages/Profile";
import Ads from "../pages/Ads";
import Projects from "../pages/Projects";
import InternalProjects from "../pages/internalPages/InternalProjects";
import ServicesMunicipal from "../pages/ServicesMunicipal"
import Places from "../pages/Places";
import Cemetery from "../pages/Cemetery";
import EblaghelEctronici from "../pages/eblaghelectronicipage/EblaghElectronici.js";
import SabtDarkhast from "../pages/eblaghelectronicipage/SabtDarkhast.js";
import MoshahedeName from "../pages/eblaghelectronicipage/MoshahedeName.js";
import { Rotate } from "hamburger-react";
import MoshahedeFile from "../pages/eblaghelectronicipage/ViewFile.js";
import ViewFile from "../pages/eblaghelectronicipage/ViewFile.js";


function Admin() {

  const { pathname } = useLocation();
  return (
    <div>
      {/* <Header /> */}
      {/* <Sidebar routes={rou tes}  toggle={false} /> */}
      <div className="rgc-main">
        <Routes>
          <Route path='/' element={<Dashboard />} />
          <Route path='/:requestId' element={<ServicesMunicipal />} />
          <Route path='/places/' element={<Navigate to="/" />} />
          <Route path='/places/:placesId' element={<Places />} />
          <Route path='news' element={<News />} />
          <Route path='celebrities' element={<Celebrities />} />
          <Route path='idea' element={<Idea />} />
          <Route path='oldproducts' element={<OldProducts />} />
          <Route path='Internalnews/:requestId' element={<InternalNews />} />
          <Route path='Internalcelebrities/:requestId' element={<InternalCelebrities />} />
          <Route path='Internalplaces/:requestId' element={<InternalPlaces />} />
          <Route path='amlak' element={<Amlak />} />
          <Route path='profile' element={<Profile />} />
          <Route path='ads' element={<Ads />} />
          <Route path='projects' element={<Projects />} />
          <Route path='internalprojects/:requestId' element={<InternalProjects />} />
          <Route path='cemetery' element={<Cemetery />} />
          <Route path='eblaghelectronici' element={<EblaghelEctronici />} />
          <Route path="/sabtdarkhast/:id" element={<SabtDarkhast />} />
          <Route path="/moshahedename/:id" element={<MoshahedeName />} />
          <Route path="/viewfile/:id" element={<ViewFile/>} />

        </Routes>
      </div>
      <Footer />
      {/* {((pathname === "/") || (pathname === "/login")) ?
        <Footer />
        :
        ""
      } */}

    </div>
  );
}

export default Admin;
